<template>
  <div>
    <m-card-list
      title="Pengelola LMS"
      id-key
      filter
      :variablePencarian="[
        { key: 'Nama', value: 'nama' },
        { key: 'Surel', value: 'surel' },
        { key: 'Peran', value: 'peran' }
      ]"
      @refresh="load"
      :items="items"
      footerLabel="Pengguna"
      @search="
        search => {
          dataPencarian = search;
          load();
        }
      "
      :page="page"
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
      footer
    >
      <template v-slot:items="{ item }">
        <v-row class="mx-3">
          <v-col :cols="$vuetify.breakpoint.smAndUp ? 12 : 10" sm="9" md="9" lg="10" xl="10">
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <p class="caption grey--text my-0 py-0">Nama</p>
                <p class="body-1 font-weight-bold my-0 py-0">
                  {{ pVal(item, "name") }}
                </p>
              </v-col>
              <v-col cols="12" sm="12" md="3" lg="3" xl="3">
                <p class="caption grey--text my-0 py-0">Surel</p>
                <p class="blue--text caption">{{ pVal(item, "email") }}</p>
              </v-col>
              <!--              <v-col cols="12" sm="12" md="3" lg="3" xl="3">-->
              <!--                <p class="caption grey&#45;&#45;text my-0 py-0">Peran</p>-->
              <!--                <v-chip v-if="item.kelasenrol.length > 0" dark :color="$user.statusColor(item.kelasenrol[0].peran_kelas.id)">{{-->
              <!--                  item.kelasenrol[0].peran_kelas.keterangan | toTitleCase-->
              <!--                }}</v-chip>-->
              <!--              </v-col>-->
            </v-row>
          </v-col>
        </v-row>
        <v-divider />
      </template>
    </m-card-list>
  </div>
</template>

<script>
// @group Global Feature
export default {
  name: "kelas-pengelola",
  components: {},
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      more_menu: []
    };
  },
  computed: {
    headers() {
      const a = [
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", align: "left", value: "" },
        { text: "", sortable: false }
      ];
      return a;
    }
  },
  activated() {
    this.load();
  },
  mounted() {
    this.load();
  },
  props: {
    kelas: {
      type: Object,
      default: null
    }
  },
  methods: {
    load() {
      var params = {
        page: this.cp,
        pengelola: true
      };

      if (this.dataPencarian) {
        var param = this.dataPencarian.param.value;
        params[param] = this.dataPencarian.s;
      }

      return this.$store
        .dispatch("kelas/getPengelola", {
          instansi_id: this.instansi_id,
          kelas_id: this.kelas.id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    }
  }
};
</script>
